import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BackToSignIn from './BackToSignIn';

const BackToSignInContainer = withRouter(connect(null, null)(BackToSignIn));

export default BackToSignInContainer;
